export default "__VITE_ASSET__C1BFEw3P__"